import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Comment from './comment';
import CommentForm from './comment_form';
import './comment_section.scss';

const CommentSection = props => (
  <div className={classnames('comment-list', props.className)}>
    <div className="mb-3">
      {props.comments.map(comment => (
        <Comment key={comment.id} {...comment} />
      ))}
    </div>
    {!props.readOnly && <CommentForm onSave={props.onSave} />}
  </div>
);

CommentSection.propTypes = {
  className: PropTypes.string,
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ),
  onSave: PropTypes.func,
  readOnly: PropTypes.bool,
};

CommentSection.defaultProps = {
  readOnly: false,
};

export default CommentSection;
